const { Geocoder, GeocoderStatus } = google.maps;

type Coords = [number, number];

export default function(placeId: string): Promise<Coords> {
  return new Promise((resolve, reject) => {
    let service = new Geocoder();

    service.geocode({ placeId }, (results, status) => {
      if (status === GeocoderStatus.OK && results && results.length > 0) {
        const point: Coords = [
          results[0].geometry.location.lat(),
          results[0].geometry.location.lng()
        ];

        resolve(point);
      } else {
        reject(status);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/fetchPlaceCoordinates.ts